import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    width: '100%',
  },
  map: {
    height: '100%',
    width: '100%',
    '& > .mapboxgl-canvas-container': {
      height: '100%',
      width: '100%',
    },
    '& .mapboxgl-ctrl-logo': {
      marginBottom: 0,
      marginLeft: '0.5rem',
    },
    '& .mapboxgl-ctrl-attrib': {
      marginBottom: 0,
    },
  },
  scaleControl: {
    marginBottom: '2rem',
    marginLeft: '0.5rem',
  },
  styleButton: {
    margin: '1em',
    zIndex: 5,
  },
}));

export default useStyles;
